import React from "react";

import classnames from "classnames";

export function IconFrame({
    icon,
    size = "md",
    color = "gray" as "gray" | "yellow" | "purple" | "destructive" | "green",
    customColor = "",
    isCircle = false,
    className = "",
    onClick = () => {},
    showBorder = false
}) {
    return (
        <div
            className={classnames(
                "iconFrame",
                customColor ? customColor : color,
                isCircle && "isCircle",
                size,
                className,
                showBorder && "showBorder"
            )}
            onClick={onClick}
        >
            <i className={icon}></i>
        </div>
    );
}
